import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from 'react';
import { Spin } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import HelpLabel from "../../../components/HelpLabel";
import { faNoteSticky } from "@fortawesome/free-solid-svg-icons/faNoteSticky";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CurrencyFormat } from "../../../components/FormattersTS";
const SalesForecastWidget = (props, exportedRef) => {
    const [loading, setLoading] = useState(false);
    const [salesForecast, setSalesForecast] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        load();
    };
    const load = () => {
        setLoading(true);
        axios.get(`/admin/v1/dashboard/sales-forecast/${props.date}`)
            .then(response => {
            setSalesForecast(response.data);
        }).catch(error => {
            setSalesForecast(null);
            axiosErrorHandler(error);
        }).finally(() => setLoading(false));
    };
    return (_jsx(Spin, { spinning: loading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-coral", children: _jsx(FontAwesomeIcon, { icon: faNoteSticky }) }), _jsx("h2", { className: "widget-value", children: salesForecast?.totalSalesExGst
                        ? _jsx(CurrencyFormat, { value: salesForecast.totalSalesExGst })
                        : _jsx(_Fragment, { children: "\u2014" }) }), _jsx("p", { children: _jsx(HelpLabel, { title: "Total Sales (ex GST)", helpText: _jsx("p", { children: "The total billable sales including all fees and levies." }) }) }), _jsx("div", { className: "widget-separator" })] }) }));
};
export default React.forwardRef(SalesForecastWidget);
